import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { ButtonBase } from './button.base'

/**
 * Component for rendering a link that looks like {@link ButtonComponent}.
 *
 * @example
 * ``` html
 * <a
 *   ftrButton
 *   href="www.url.com"
 *   color="secondary"
 *   size="small"
 *   class="custom-class"
 * >
 *   I'm a link!
 * </a>
 * ```
 */
@Component({
  standalone: true,
  selector: 'a[ftrButton]',
  styleUrls: ['./button.component.css'],
  template: '<ng-content></ng-content>',
  exportAs: 'ftrButton',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnchorComponent extends ButtonBase {}
